<template>
    <div class="lang" @click="isShowDropDown = !isShowDropDown" v-click-outside="closeDropDown">
        <div class="lang__face">
            <div class="lang__label">
              {{
                locale === 'ru' ? 'Русский (ru)' :
                locale === 'en' ? 'English (en)' :
                'Кыргызча (ky)'
              }}
            </div>
            <svg class="icon icon_size_small">
                <use xlink:href="/img/sprites/icons-sprite.svg#icon-arrow-down"></use>
            </svg>
        </div>
        <div v-if="isShowDropDown" class="lang__dropdown">
            <div @click="switchLang(lang.key)" class="lang__label lang__label--bottom" v-for="lang in languages" :key="lang.key">
                {{lang.title}}
            </div>
        </div>
    </div>
</template>

<script setup>
import {useI18n} from 'vue-i18n'
import {onMounted, ref} from "vue";

const {locale} = useI18n()

const isShowDropDown = ref(false)

const switchLang = (key) => {
    locale.value = key
    localStorage.setItem('lang', JSON.stringify(locale.value))
}

const closeDropDown = () => {
    isShowDropDown.value = false
}

const languages = [
    {
        title: 'Русский (ru)',
        key: 'ru'
    },
    {
        title: 'English (en)',
        key: 'en'
    },
    {
        title: 'Кыргызча (ky)',
        key: 'ky'
    }
]

onMounted(() => {
    const lang = JSON.parse(localStorage.getItem('lang'));
    if(lang) {
        locale.value = lang
    }
})
// import { mapGetters } from 'vuex'
//
// export default {
//     name: 'Lang',
//
//      computed: {
//         ...mapGetters(['user'])
//     }
// }
</script>

<style lang="scss" scoped>
@import '../scss/lang.scss';
</style>
